/* ====================================
   CART DRAWER - VERSION V6.0 ULTRA-CLEAN
   Solution finale : désactive l'animation Shopify
   ==================================== */

(function() {
  'use strict';
  
  // ========================================
  // 1. DÉSACTIVER L'ANIMATION SHOPIFY
  // ========================================
  
  function disableShopifyAnimation() {
    // Supprimer la classe "animate" ajoutée par Shopify
    const drawer = document.querySelector('.drawer');
    if (!drawer) return;
    
    // Observer et retirer immédiatement la classe "animate"
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('animate')) {
            target.classList.remove('animate');
          }
        }
      });
    });
    
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // ========================================
  // 2. FIX SHOPPING BAG LINK CENTRAGE
  // ========================================
  
  function fixShoppingBagLink() {
    const wrapper = document.querySelector('.cart-drawer__shopping-bag-wrapper');
    if (wrapper) {
      wrapper.style.cssText = 'display: flex !important; justify-content: center !important; align-items: center !important; width: 100% !important; margin-top: 1.5rem !important; padding: 0 !important;';
    }
    
    const link = document.querySelector('.cart-drawer__shopping-bag-link');
    if (link) {
      link.style.cssText = 'font-family: "Work Sans", sans-serif !important; font-size: 1.3rem !important; font-weight: 400 !important; color: #000000 !important; text-decoration: none !important; position: relative !important; display: inline-block !important; cursor: pointer !important; letter-spacing: 0.02em !important;';
    }
  }
  
  // ========================================
  // 2b. FIX CART ICON BOLD
  // ========================================
  
function fixCartIconWeight() {
    const cartBubble = document.querySelector('#cart-icon-bubble');
    if (cartBubble) {
      const span = cartBubble.querySelector('span');
      if (span && !span.classList.contains('cart-count-hand')) {
        span.style.cssText = 'font-size: 14px !important; font-weight: 400 !important; letter-spacing: 0.05em !important;';
      }
    }
  }
  
  // ========================================
  // 3. INJECTION CSS
  // ========================================
  
  function injectCSS() {
    if (document.getElementById('cart-stable-css')) return;
    
    const style = document.createElement('style');
    style.id = 'cart-stable-css';
    style.textContent = `
      /* === FIX CART ICON WEIGHT === */
      #cart-icon-bubble,
      #cart-icon-bubble span:not(.cart-count-hand),
      .cart-icon-bubble span:not(.cart-count-hand) {
        font-weight: 600 !important;
      }
      /* Le compteur suit exactement la typo du mot "cart" (27/09/2026) */
      #cart-icon-bubble .cart-count-hand {
        font-family: 'Work Sans', sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        letter-spacing: 0.05em !important;
        color: #000 !important;
        line-height: 1 !important;
        margin-top: 0 !important;
      }
      
      /* === FIX SHOPPING BAG LINK === */
      .cart-drawer__shopping-bag-wrapper {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        width: 100% !important;
        margin-top: 1.5rem !important;
        padding: 0 !important;
      }
      
      .cart-drawer__shopping-bag-link {
        font-family: 'Work Sans', sans-serif !important;
        font-size: 1.3rem !important;
        font-weight: 400 !important;
        color: #000000 !important;
        text-decoration: none !important;
        position: relative !important;
        display: inline-block !important;
        cursor: pointer !important;
        letter-spacing: 0.02em !important;
      }
      
      .cart-drawer__shopping-bag-link::after {
        content: '' !important;
        position: absolute !important;
        bottom: -2px !important;
        left: 0 !important;
        width: 0 !important;
        height: 1px !important;
        background-color: #000000 !important;
        transition: width 0.3s ease !important;
      }
      
      .cart-drawer__shopping-bag-link:hover::after {
        width: 100% !important;
      }
      
      .cart-drawer__shopping-bag-link:hover {
        text-decoration: none !important;
        color: #000000 !important;
      }
      /* === FORCER LA DÉSACTIVATION DE L'ANIMATION SHOPIFY === */
      .drawer.animate,
      .drawer.animate .drawer__inner {
        animation: none !important;
      }
      
      /* === VERROUILLAGE PRIX === */
      .cart-drawer .cart-item {
        display: grid !important;
        grid-template-columns: auto 1fr !important;
        grid-template-rows: auto auto !important;
      }
      
      .cart-drawer .cart-item__media {
        grid-column: 1 !important;
        grid-row: 1 / 3 !important;
      }
      
      .cart-drawer .cart-item__details {
        grid-column: 2 !important;
        grid-row: 1 !important;
        display: flex !important;
        flex-direction: column !important;
      }
      
      .cart-drawer .cart-item__totals {
        position: static !important;
        grid-column: 2 !important;
        grid-row: 1 !important;
        order: 10 !important;
        display: flex !important;
      }
      
      .cart-drawer .cart-item__quantity {
        grid-column: 2 !important;
        grid-row: 2 !important;
        padding-top: 0 !important;
      }
      
      /* === MASQUER SPINNER === */
      .cart-drawer .loading__spinner,
      .cart-drawer .loading-overlay__spinner,
      .drawer .loading__spinner {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
      }
      
      /* === BOUTON REMOVE - VERSION CORRIGÉE === */
      cart-remove-button {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-shrink: 0 !important;
      }
      
      cart-remove-button button,
      cart-remove-button .cart-remove-button,
      button.cart-remove-button,
      .cart-remove-button {
        all: unset !important;
        box-sizing: border-box !important;
        position: relative !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 20px !important;
        height: 20px !important;
        min-width: 20px !important;
        max-width: 20px !important;
        min-height: 20px !important;
        max-height: 20px !important;
        padding: 0 !important;
        margin: 0 !important;
        margin-left: 8px !important;
        background: transparent !important;
        border: none !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        cursor: pointer !important;
        opacity: 0.5 !important;
        transition: opacity 0.2s ease !important;
      }
      
      cart-remove-button button > *,
      cart-remove-button button .svg-wrapper,
      cart-remove-button button svg {
        display: none !important;
        visibility: hidden !important;
        width: 0 !important;
        height: 0 !important;
        opacity: 0 !important;
      }
      
      cart-remove-button button::before,
      cart-remove-button button::after,
      .cart-remove-button::before,
      .cart-remove-button::after {
        content: '' !important;
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        width: 12px !important;
        height: 1px !important;
        background-color: #000000 !important;
        border: none !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        pointer-events: none !important;
        z-index: 10 !important;
      }
      
      cart-remove-button button::before,
      .cart-remove-button::before {
        transform: translate(-50%, -50%) rotate(45deg) !important;
      }
      
      cart-remove-button button::after,
      .cart-remove-button::after {
        transform: translate(-50%, -50%) rotate(-45deg) !important;
      }
      
      cart-remove-button button:hover,
      .cart-remove-button:hover {
        opacity: 1 !important;
        box-shadow: none !important;
      }
      
      cart-remove-button button:hover::before,
      cart-remove-button button:hover::after {
        box-shadow: none !important;
      }
      
      /* Transitions douces */
      .cart-drawer .price {
        transition: opacity 0.2s ease !important;
      }

      /* === POSITION DE "- quantite + supprimer" ===
         L'image occupe les 2 lignes de la grille. Avec
         grid-template-rows: auto auto, une photo verticale etirait la
         ligne 1 et repoussait la quantite tout en bas.
         Ligne 1 = auto (titre / taille / prix), ligne 2 = 1fr : c'est la
         ligne 2 qui absorbe le reste de la hauteur de l'image, et la
         quantite est collee en haut de cette ligne, donc juste sous le
         prix — quel que soit le format de la photo.
         Applique sur TOUTES les tailles d'ecran (ordinateur compris)
         depuis le 27/09/2026.
         >>> Ecart prix <-> quantite : padding-top de .cart-item__quantity. */
      .cart-drawer .cart-item {
        grid-template-rows: auto 1fr !important;
      }

      .cart-drawer .cart-items .cart-item__quantity {
        align-self: start !important;
        padding-top: 0 !important;
      }

      @media screen and (max-width: 749px) {
        /* Mobile uniquement : descend l'ensemble du bloc de droite
           (titre / taille / prix ET la quantite qui suit). */
        .cart-drawer .cart-item__details {
          padding-top: 1.8rem !important;
        }
      }

      /* === ORDINATEUR : bloc d'informations centre sur la photo ===
         Les photos produit sont verticales et hautes. Avec le bloc de
         droite cale en haut, le titre se retrouvait loin du centre de
         l'image. La grille gagne donc deux lignes ressort (1fr), une
         au-dessus et une en dessous : le bloc titre / taille / prix /
         quantite est pousse au milieu de la hauteur de la photo.
         Mobile garde le comportement precedent (bloc en haut), ou la
         place manque pour centrer sans creer de grands vides.
         >>> Ecart prix <-> quantite : padding-top de .cart-item__quantity. */
      @media screen and (min-width: 750px) {
        .cart-drawer .cart-item {
          grid-template-rows: 1fr auto auto 1fr !important;
        }

        .cart-drawer .cart-item__media {
          grid-row: 1 / -1 !important;
          align-self: start !important;
        }

        .cart-drawer .cart-item__details {
          grid-row: 2 !important;
          padding-top: 0 !important;
        }

        /* Filet de securite : si le prix n'a pas encore ete deplace
           dans les details par le script, il reste sur la meme ligne. */
        .cart-drawer .cart-item__totals {
          grid-row: 2 !important;
        }

        .cart-drawer .cart-items .cart-item__quantity {
          grid-row: 3 !important;
          align-self: start !important;
          padding-top: 0 !important;
        }
      }

      /* === NOTE DU PANIER : police reduite (27/09/2026) === */
      .cart-drawer .cart__note .field__input,
      .cart-drawer .cart__note .text-area,
      .cart-drawer #CartDrawer-Note {
        font-size: 1.15rem !important;
        line-height: 1.45 !important;
      }

      .cart-drawer #CartDrawer-Note::placeholder {
        font-size: 1.15rem !important;
        opacity: 0.55 !important;
      }

      /* ====================================================
         TTWN 13/10/2026 — PANIER PLUS COMPACT
         1. Quantite collee au prix (padding-top 6px retire
            ci-dessus).
         2. Selecteur "- 1 +" moins haut (45px -> 30px).
         3. Mobile : photo 150px -> 92px et marges resserrees,
            pour voir environ deux fois plus d'articles.
         ==================================================== */

      /* Selecteur de quantite : hauteur reduite.
         >>> Hauteur du bloc quantite : min-height de .quantity. */
      .cart-drawer .quantity {
        min-height: 3rem !important;
      }

      .cart-drawer .quantity__button {
        padding: 0.2rem !important;
      }

      .cart-drawer .cart-item__quantity-wrapper {
        align-items: center !important;
      }

      @media screen and (max-width: 749px) {
        /* La hauteur d'une ligne du panier est imposee par la photo :
           c'est elle qu'il faut reduire en premier. 92px de large
           donnent environ 138px de haut pour une photo verticale 2/3,
           contre 225px avec les 150px d'origine.
           >>> Taille des photos du panier : width de .cart-item__image. */
        .cart-drawer .cart-item__image {
          width: 92px !important;
          height: auto !important;
        }

        .cart-drawer .cart-item {
          padding: 1.2rem 0 !important;
          gap: 0.2rem 1.2rem !important;
        }

        /* Le bloc de droite n'a plus besoin d'etre descendu de 1.8rem :
           il fait desormais presque la hauteur de la photo. */
        .cart-drawer .cart-item__details {
          padding-top: 0.2rem !important;
        }

        .cart-drawer .cart-item__name {
          font-size: 1.2rem !important;
          line-height: 1.3 !important;
        }

        .cart-drawer .cart-item__details .product-option,
        .cart-drawer .cart-item__details dl,
        .cart-drawer .cart-item__price-wrapper .price {
          font-size: 1.1rem !important;
          line-height: 1.35 !important;
        }

        .cart-drawer .quantity {
          min-height: 2.8rem !important;
          min-width: 86px !important;
        }
      }
    `;
    
    document.head.appendChild(style);
  }
  
  // ========================================
  // 3. RECRÉER BOUTONS REMOVE
  // ========================================
  
  function recreateRemoveButtons() {
    const removeButtons = document.querySelectorAll('cart-remove-button button');
    
    removeButtons.forEach(function(btn) {
      if (btn.dataset.recreated) return;
      btn.dataset.recreated = 'true';
      
      while (btn.firstChild) {
        btn.removeChild(btn.firstChild);
      }
    });
  }
  
  // ========================================
  // 4. FORCER LE PRIX EN PLACE
  // ========================================
  
  let movingPrice = false;

  function forcePriceInDetails() {
    // Garde anti-reentrance : on deplace du DOM, ce qui reveille les
    // MutationObserver ci-dessous, qui rappellent cette fonction.
    if (movingPrice) return;
    movingPrice = true;

    // Scope au TIROIR uniquement. Avant, le selecteur etait global : ce script
    // etant charge sur toutes les pages qui contiennent le tiroir (dont /cart),
    // il deplacait aussi le prix total DANS le bloc details de la page panier,
    // ce qui cassait la mise en page mobile de /cart.
    const cartItems = document.querySelectorAll('.cart-drawer .cart-item');
    
    cartItems.forEach(function(item) {
      const details = item.querySelector('.cart-item__details');
      const totals = item.querySelector('.cart-item__totals');
      
      if (!details || !totals) return;
      
      if (!details.contains(totals)) {
        if (totals.parentNode) {
          totals.parentNode.removeChild(totals);
        }
        details.appendChild(totals);
      }
      
      if (totals.style.order !== '10') totals.style.order = '10';
    });

    movingPrice = false;
  }
  
  // ========================================
  // 5. AJOUTER "SIZE: ONE SIZE"
  // ========================================
  
  function addOneSize() {
    const cartItems = document.querySelectorAll('.cart-item');
    
    cartItems.forEach(function(item) {
      const details = item.querySelector('.cart-item__details');
      if (!details) return;
      
      const dlElement = details.querySelector('dl');
      const existingOneSize = details.querySelector('.js-one-size-label');
      
      if (!dlElement && !existingOneSize) {
        const newDl = document.createElement('dl');
        newDl.className = 'js-one-size-label';
        
        const productOption = document.createElement('div');
        productOption.className = 'product-option';
        productOption.style.fontSize = '1.05rem';
        
        const dt = document.createElement('dt');
        dt.textContent = 'Size:';
        dt.style.display = 'inline';
        
        const dd = document.createElement('dd');
        dd.textContent = ' One Size';
        dd.style.display = 'inline';
        
        productOption.appendChild(dt);
        productOption.appendChild(dd);
        newDl.appendChild(productOption);
        
        const title = details.querySelector('.cart-item__name');
        if (title) {
          title.insertAdjacentElement('afterend', newDl);
        }
      }
    });
  }
  
  // ========================================
  // 6. OBSERVER ITEMS
  // ========================================
  
  function observeItems() {
    const cartItems = document.querySelectorAll('.cart-item');
    
    cartItems.forEach(function(item) {
      if (item.dataset.observed) return;
      item.dataset.observed = 'true';
      
      const observer = new MutationObserver(function() {
        forcePriceInDetails();
        recreateRemoveButtons();
      });
      
      observer.observe(item, {
        childList: true,
        subtree: true
      });
    });
  }
  
  // ========================================
  // 7. MONITORING CONTINU
  // ========================================
  
  /* AVANT : requestAnimationFrame en boucle INFINIE sur toutes les pages.
     Un querySelectorAll('.cart-item') + parcours du DOM a chaque frame,
     en permanence : c'est ce qui rendait l'ajout au panier (et le reste
     de la page) lent. Maintenant la surveillance ne tourne que pendant
     une courte fenetre apres chaque changement du panier. */
  let rafId = null;
  let monitorUntil = 0;

  function continuousMonitoring() {
    forcePriceInDetails();
    if (Date.now() < monitorUntil) {
      rafId = requestAnimationFrame(continuousMonitoring);
    } else {
      rafId = null;
    }
  }

  function startMonitoring(duration) {
    monitorUntil = Date.now() + (duration || 700);
    if (rafId === null) rafId = requestAnimationFrame(continuousMonitoring);
  }
  
  // ========================================
  // 8. INIT
  // ========================================
  
  function init() {
    disableShopifyAnimation();
    injectCSS();
    forcePriceInDetails();
    addOneSize();
    recreateRemoveButtons();
    observeItems();
    fixShoppingBagLink();
    fixCartIconWeight();
    startMonitoring(700);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // ========================================
  // 9. OBSERVER DRAWER
  // ========================================
  
  const drawer = document.querySelector('.drawer');
  if (drawer) {
    const obs = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('active')) {
            setTimeout(init, 50);
          }
        }
      });
    });
    
    obs.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // ========================================
  // 10. OBSERVER CONTENU
  // ========================================

  /* IMPORTANT : Dawn remplace le innerHTML de #CartDrawer (ajout au panier)
     ou de .drawer__inner (changement de quantite). <cart-drawer-items> est
     donc DETRUIT a chaque re-rendu : un observateur pose dessus devient muet.
     On observe la racine <cart-drawer>, qui elle ne bouge jamais.
     forcePriceInDetails() est appele immediatement (les callbacks de
     MutationObserver s'executent avant le paint) pour que le prix
     n'apparaisse jamais une frame au mauvais endroit. */
  const cartDrawerRoot = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');
  if (cartDrawerRoot) {
    let rerenderTimer = null;

    const obs = new MutationObserver(function () {
      forcePriceInDetails();

      clearTimeout(rerenderTimer);
      rerenderTimer = setTimeout(function () {
        forcePriceInDetails();
        addOneSize();
        recreateRemoveButtons();
        observeItems();
        fixShoppingBagLink();
        fixCartIconWeight();
        startMonitoring(500);
      }, 30);
    });

    obs.observe(cartDrawerRoot, {
      childList: true,
      subtree: true
    });
  }

  // ========================================
  // 11. OBSERVER CART ICON BUBBLE
  // ========================================
  
  const cartIconBubble = document.querySelector('#cart-icon-bubble');
  if (cartIconBubble) {
    const obsIcon = new MutationObserver(function() {
      setTimeout(fixCartIconWeight, 10);
    });
    
    obsIcon.observe(cartIconBubble, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Observer le parent aussi car le bubble entier peut être remplacé
  const headerIcons = document.querySelector('.header__icons') || document.querySelector('header');
  if (headerIcons) {
    const obsHeader = new MutationObserver(function() {
      setTimeout(fixCartIconWeight, 10);
    });
    
    obsHeader.observe(headerIcons, {
      childList: true,
      subtree: true
    });
  }
  
})();